export default __webpack_public_path__ + "static/media/hht2_home_img_EP19.8240bb3b.png";